export enum TRANSLATION_TYPE {
  COMMON = 'common',
}
